export default __webpack_public_path__ + "static/media/character-akitane-kashin.fea5966d.png";